module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-wrap"
  }, _vm._l((_vm.navs), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('a', [(_vm.haveActive) ? _c('div', {
      class: {
        active: _vm.activeTab === index
      },
      on: {
        "click": function($event) {
          return _vm.change(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.label ?
      item.label : item) + "\n      ")]) : _c('div', {
      class: {
        active: _vm.currentTab === index
      },
      on: {
        "click": function($event) {
          return _vm.change(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.label ? item.label :
      item) + "\n      ")])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-a0ba607e!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Nav.vue
// module id = 306
// module chunks = 0